// Faithful port of the Deal Tracker commission/company-net engine.
// Business rules: tiered lead cost (Company Generated only); agent 42%/70%;
// broker split % of agent commission; company net = gross − all deductions.

export const leadCostPct = (v) =>
  v >= 300000 ? 0.4 : v >= 225000 ? 0.35 : v >= 150000 ? 0.3 : v >= 75000 ? 0.25 : 0.15;

export function computeFinancials(f) {
  const v = parseFloat(f.contract_value) || 0;
  const r = parseFloat(f.commission_rate) || 0;
  const gross = (v * r) / 100;
  const lead = f.lead_generated_by === "Company Generated" ? gross * leadCostPct(v) : 0;
  let agent = 0;
  if (f.lead_generated_by === "Company Generated") agent = (gross - lead) * 0.42;
  else if (f.lead_generated_by === "Agent Generated") agent = gross * 0.7;
  const broker = f.broker_split === "yes" ? agent * ((parseFloat(f.broker_split_percentage) || 20) / 100) : 0;
  const fees =
    (parseFloat(f.risk_management_fee) || 0) +
    (parseFloat(f.cap_fee_100) || 0) +
    (parseFloat(f.transaction_review_fee) || 0) +
    (parseFloat(f.transaction_coordinator_fee) || 0) +
    (parseFloat(f.referral_fee) || 0);
  const companyNet = gross - (lead + agent + broker + fees);
  return { gross, lead, agent, broker, companyNet };
}
